export function make_graph_N(input_data) {

    // define process
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 0 - input_data
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let allRelations = input_data.relations
        // input_data.relations = [{rtype: "", rtable:[]}, {...}, ...]
    let Ranks = input_data.ranks

    // 1 - make empty GraphN

    let GraphN = {
            node_library: {},
            node_list: [],
            show_level: {},
            visited: {},
            level_table: [],
            link_table: [],
            info: {
                graph_type: "",
                n_ranks: Ranks.length,
                n_nodes: 0,
                max_level: Ranks.length,
            }
        }
        // console.log("[FUNCTIONS] tree_node : empty GraphN ", GraphN)


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 2 - make node_library with Ranks
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let empty_node_unit = {
        info: { doc_key: null, rank: null },
        din: { total: 0, R: 0, T: 0, C: 0, V: 0 },
        dout: { total: 0, R: 0, T: 0, C: 0, V: 0 },
        ins: { total: [], R: [], T: [], C: [], V: [] },
        outs: { total: [], R: [], T: [], C: [], V: [] },
    }

    let rank_nodes_key = []

    let temp_node_unit = {}
    let node_count = 0

    for (let r = 0; r < Ranks.length; r++) {
        rank_nodes_key = Ranks[r]

        rank_nodes_key.forEach(v => {
            node_count += 1
            temp_node_unit = JSON.parse(JSON.stringify(empty_node_unit))
            temp_node_unit.info.doc_key = v
            temp_node_unit.info.rank = r

            //add v temp_node_library
            GraphN.node_library[v] = temp_node_unit
            GraphN.node_list.push(v)

            //initialize
            GraphN.show_level[v] = 0
            GraphN.visited[v] = false

            //graph_type
            if (v == 'project') {
                GraphN.info.graph_type = "project"
            } else if (v == 'document') {
                GraphN.info.graph_type = "document"
            }
        })
    }
    //after watching all Ranks
    GraphN.info.n_nodes = node_count

    // console.log("[FUNCTIONS] tree_node : working node_library ", GraphN)


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 3 - make link table
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let aR = []
    let rUnit = []

    //for work to adjust leveling
    // nodes_to_adjust_level
    let nAdjLv = []

    for (let rt = 0; rt < allRelations.length; rt++) {
        aR = allRelations[rt]

        if (aR.rtable.length > 0) {
            rUnit = []
                //rUnit[0] - start , rUnit[1] - end

            for (let ru = 0; ru < aR.rtable.length; ru++) {
                rUnit = aR.rtable[ru]

                //start node is visited
                GraphN.visited[rUnit[0]] = true

                //check self reference
                if (rUnit[0] == rUnit[1]) {
                    // console.log("[ERROR] self relation ", aR.rtype, rUnit)
                } else {

                    //aR.rtype = R, T, C, V

                    //into start node
                    GraphN.node_library[rUnit[0]].outs[aR.rtype].push(rUnit[1])
                    GraphN.node_library[rUnit[0]].outs.total.push(rUnit[1])

                    //into end node
                    GraphN.node_library[rUnit[1]].ins[aR.rtype].push(rUnit[0])
                    GraphN.node_library[rUnit[1]].ins.total.push(rUnit[0])

                    //into link table
                    GraphN.link_table.push([rUnit[0], rUnit[1], aR.rtype])

                    //put nodes to adjust level
                    if (GraphN.show_level[rUnit[0]] >= GraphN.show_level[rUnit[1]]) {
                        GraphN.show_level[rUnit[1]] = GraphN.show_level[rUnit[0]] + 1
                            //check end node already visited
                        if (GraphN.visited[rUnit[1]]) {
                            nAdjLv.push(rUnit[1])
                        }
                    }

                    //max level of GraphN
                    if (GraphN.info.max_level < GraphN.show_level[rUnit[1]]) {
                        GraphN.info.max_level = GraphN.show_level[rUnit[1]]
                    }
                }
            }
        }
    }
    // console.log("[FUNCTIONS] tree_node : working node_library & link table ", GraphN)


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 4 - make show level
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let n_to_work = nAdjLv.length
        // console.log("number of nodes to adjust level : start - ", n_to_work)

    //new nodes to adjust
    let new_nAdj = []

    //limit to recursive
    let check_loop = 30

    // check closed circle
    let distance_matrix = {}

    while (n_to_work > 0) {
        for (let l = 0; l < check_loop; l++) {

            new_nAdj = []

            //outs of node to adjust
            let outs_na = []
            let na_start = null
            let na_end = null

            for (let na = 0; na < n_to_work; na++) {

                na_start = nAdjLv[na]
                outs_na = GraphN.node_library[na_start].outs.total

                // check paths circle
                let distance_1 = outs_na
                let distance_2 = []
                let distance_3 = []

                distance_matrix[na_start] = { d: 1, list: distance_1 }

                if (outs_na.length > 0) {

                    for (let otn = 0; otn < outs_na.length; otn++) {

                        //start node = nAdjLv[na]
                        //end node = outs_na[otn]
                        na_end = outs_na[otn]

                        // for distance_2
                        let outs_extended = GraphN.node_library[na_end].outs.total
                        if (outs_extended.length > 0) {
                            // check start point
                            if (outs_extended.includes(na_start)) {
                                // console.log("[ERROR] FIND LOOP : ", na_start, na_end, outs_extended)
                                // cut the link
                                const i_na_start = outs_extended.indexOf(na_start)
                                if (i_na_start > -1) {
                                    outs_extended.splice(i_na_start, 1)
                                    GraphN.node_library[na_end].outs.total = outs_extended
                                }
                            }
                            distance_2.push(...outs_extended)
                            distance_2 = [...new Set(distance_2)]
                        }

                        if (GraphN.show_level[na_start] >= GraphN.show_level[na_end]) {
                            //modify level of end node
                            GraphN.show_level[na_end] = GraphN.show_level[na_start] + 1

                            new_nAdj.push(na_end)

                            //max level of GraphN
                            if (GraphN.info.max_level < GraphN.show_level[na_end]) {
                                GraphN.info.max_level = GraphN.show_level[na_end]
                            }
                        }
                    }

                    // // set distance_2
                    // distance_2 = [...new Set(distance_2)]

                    // // check circle
                    // if (distance_2.includes(na_start)) {
                    //   console.log("[ERROR] FIND LOOP - distance 2: ", na_start, distance_1, distance_2)
                    //   break;
                    // } else {
                    //   distance_matrix[na_start] = { r: 2, list: distance_2 }
                    //   for (let d2 = 0; d2 < distance_2.length; d2++) {
                    //     let nd2 = distance_2[d2]
                    //     let a_nd3 = GraphN.node_library[nd2].outs.total
                    //     distance_3.push(...a_nd3)
                    //   }
                    //   distance_3 = [...new Set(distance_3)]
                    //   if (distance_3.includes(na_start)) {
                    //     console.log("[ERROR] FIND LOOP - distance 3: ", na_start, distance_1, distance_2, distance_3)
                    //     break;
                    //   }
                    // }
                }
            }
            if (new_nAdj.length == 0) {
                // console.log("finish while loop. n of loops ", l)
                n_to_work = 0
                break;
            } else {
                nAdjLv = JSON.parse(JSON.stringify(new_nAdj))
                new_nAdj = []
                n_to_work = nAdjLv.length
                    // console.log("number of nodes to adjust level : working - ", n_to_work)
            }
        }
        // break emergency
        n_to_work = 0
            // console.log("[ERROR] while-loop")
    }
    //test
    GraphN.link_table.forEach(v => {
        if (GraphN.show_level[v[0]] >= GraphN.show_level[v[1]]) {
            // console.log("[ERROR] leveling while loop ", v, " start ", GraphN.node_library[v[0]], " end ", GraphN.node_library[v[1]])
            // console.log("start level : ", GraphN.show_level[v[0]], " end level : ", GraphN.show_level[v[1]])
        }
    })

    // console.log("[FUNCTIONS] tree_node : working node_library & link table & show_level ", GraphN)


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 5 - make level table, arrange ins, outs
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //initialize level table
    for (let nlv = 0; nlv < GraphN.info.max_level + 1; nlv++) {
        GraphN.level_table.push([])
    }

    let nx = {}
    let nx_key = null
    var rType = ["total", "R", "T", "C", "V"]

    for (let nk = 0; nk < GraphN.node_list.length; nk++) {
        nx_key = GraphN.node_list[nk]
        nx = GraphN.node_library[nx_key]

        rType.forEach(r => {
            nx.outs[r] = [...new Set(nx.outs[r])]
            nx.ins[r] = [...new Set(nx.ins[r])]
            nx.dout[r] = nx.outs[r].length
            nx.din[r] = nx.ins[r].length
        })
    }

    GraphN.node_list.forEach(n => {
        let lev = GraphN.show_level[n]
        GraphN.level_table[lev].push(n)
    })

    // console.log("[FUNCTIONS] tree_node : finalize ", GraphN)

    return GraphN
}


// WEBPACK FOOTER //
// ./src/custom/tree_node.js